import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import FrontHeader from '../components/common/FrontHeader';
import FrontFooter from '../components/common/FrontFooter';
import './VerifyEmail.css';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const VerifyEmail = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [code, setCode] = useState(['', '', '', '', '', '']);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [resendLoading, setResendLoading] = useState(false);
  const [timer, setTimer] = useState(0);
  
  const email = location.state?.email || localStorage.getItem('pending_verification_email') || '';

  useEffect(() => {
    if (email) localStorage.setItem('pending_verification_email', email);
    const savedTimer = localStorage.getItem('verification_timer');
    if (savedTimer && parseInt(savedTimer) > 0) setTimer(parseInt(savedTimer));
    else setTimer(60);
  }, [email]);

  useEffect(() => {
    if (timer > 0) {
      const interval = setInterval(() => { setTimer(prev => { const newTime = prev - 1; localStorage.setItem('verification_timer', newTime); return newTime; }); }, 1000);
      return () => clearInterval(interval);
    }
  }, [timer]);

  const handleCodeChange = (index, value) => {
    if (value.length > 1) return;
    const newCode = [...code];
    newCode[index] = value;
    setCode(newCode);
    if (value && index < 5) document.getElementById(`code-input-${index + 1}`)?.focus();
  };

  const handleVerify = async () => {
    const verificationCode = code.join('');
    if (verificationCode.length !== 6) { setError('Please enter the 6-digit verification code'); return; }
    setLoading(true); setError(''); setSuccess('');
    try {
      const response = await fetch(`${API_BASE}/auth/verify-email`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ email, code: verificationCode }) });
      const data = await response.json();
      if (data.success) {
        localStorage.setItem('marilink_token', data.token);
        localStorage.setItem('marilink_user', JSON.stringify(data.user));
        localStorage.removeItem('pending_verification_email');
        localStorage.removeItem('verification_timer');
        setSuccess('Email verified successfully! Redirecting...');
        setTimeout(() => navigate(`/${data.user.role}/dashboard`), 2000);
      } else setError(data.message || 'Verification failed');
    } catch (err) { setError('Network error. Please try again.'); }
    finally { setLoading(false); }
  };

  const handleResendCode = async () => {
    if (timer > 0) { setError(`Please wait ${timer} seconds before requesting a new code`); return; }
    setResendLoading(true); setError(''); setSuccess('');
    try {
      const response = await fetch(`${API_BASE}/auth/resend-verification`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ email }) });
      const data = await response.json();
      if (data.success) { setSuccess('New verification code sent to your email!'); setTimer(60); setCode(['', '', '', '', '', '']); document.getElementById('code-input-0')?.focus(); }
      else setError(data.message || 'Failed to resend code');
    } catch (err) { setError('Network error. Please try again.'); }
    finally { setResendLoading(false); }
  };

  const handleKeyPress = (e) => { if (e.key === 'Enter') handleVerify(); };

  return (
    <div className="verify-email-page">
      <FrontHeader />
      <div className="verify-main">
        <div className="verify-container"><div className="verify-icon"><i className="fas fa-envelope-open-text"></i></div><h1>Verify Your Email</h1><p className="verify-subtitle">We've sent a 6-digit verification code to<br /><strong>{email}</strong></p>{error && <div className="verify-error"><i className="fas fa-exclamation-circle"></i>{error}</div>}{success && <div className="verify-success"><i className="fas fa-check-circle"></i>{success}</div>}<div className="code-inputs">{code.map((digit, index) => (<input key={index} id={`code-input-${index}`} type="text" maxLength="1" value={digit} onChange={(e) => handleCodeChange(index, e.target.value)} onKeyPress={handleKeyPress} className="code-input" autoFocus={index === 0} />))}</div><button className="verify-btn" onClick={handleVerify} disabled={loading}>{loading ? <><i className="fas fa-spinner fa-spin"></i> Verifying...</> : 'Verify Email'}</button><div className="resend-section"><p>Didn't receive the code?</p><button className="resend-btn" onClick={handleResendCode} disabled={resendLoading || timer > 0}>{resendLoading ? 'Sending...' : timer > 0 ? `Resend in ${timer}s` : 'Resend Code'}</button></div></div>
      </div>
      <FrontFooter />
    </div>
  );
};

export default VerifyEmail;